import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { getFilteredStationIdsForReport } from '../quality-result/filter-quality-stations-by-status';
import { useReportViewStore } from './view.store';
import { StreamQualityReportResponseDto } from '../stream-quality.types';

/**
 * Returns station IDs that match the active station-status chip filter.
 */
export function useFilteredStationIds(report: StreamQualityReportResponseDto): string[] {
  const stationStatusFilter = useReportViewStore(useShallow((state) => state.stationStatusFilter));

  return useMemo(
    () => getFilteredStationIdsForReport(report, stationStatusFilter),
    [report, stationStatusFilter],
  );
}
